export default __webpack_public_path__ + "static/media/home-consulting-tab-img-03.521351b0.jpg";